import React from "react";
import { Grid } from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { useTranslation } from "react-i18next";
import publicMainStyle from "assets/jss/components/publicMainStyles";
import LanguageSelector from "components/menu/LanguageSelector";
import { Forbidden } from "@totalsoft/rocket-webapp-components-deprecated";
import defaultLogo from "assets/img/logo.svg";

const useStyles = makeStyles(publicMainStyle);

const InvalidUser = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  const theme = useTheme();
  const { logo } = theme;

  return (
    <>
      <img src={logo || defaultLogo} />
      <Forbidden forbiddenText={t("General.InvalidUser")} />
      <Grid container alignItems="center" justifyContent="space-between" className={classes.gridFooter}>
        <Grid item className={classes.gridFooterItem}>
          <LanguageSelector miniActive={false} />
        </Grid>
      </Grid>
    </>
  );
};

export default InvalidUser;
